import axios from "axios";

function api() {
	// 創建axios
	const API_URL = process.env.REACT_APP_API_URL;
	const instance = axios.create({
		baseURL: API_URL,
	});

	
	return instance;
}

export default api();
